import React from "react";
import { UI } from "@wwimmo/ui";
import styles from "./AssemblyRealestateListRow.module.css";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { AssemblyRealestate } from "src/stores/assemblies/AssemblyStore";

const AssemblyRealestateListRowDesktopBase = (props: {
    assemblyrealestate: AssemblyRealestate;
    onRemoveRealestate: any;
    widths: number[];
}) => {
    const { realestate } = props.assemblyrealestate;
    const { widths, onRemoveRealestate } = props;

    if (realestate === undefined) {
        return <div>/</div>;
    }

    const formatAddress =
        realestate.houses !== undefined && realestate.houses.length > 0
            ? `${
                  realestate.houses[0].street && realestate.houses[0].housenumber
                      ? `${realestate.houses[0].street} ${realestate.houses[0].housenumber}`
                      : ""
              }
     ${
         realestate.houses[0].street &&
         realestate.houses[0].housenumber &&
         realestate.houses[0].zip &&
         realestate.houses[0].city
             ? ", "
             : ""
     }
     ${
         realestate.houses[0].zip && realestate.houses[0].city
             ? `${realestate.houses[0].zip} ${realestate.houses[0].city}`
             : ""
     }`
            : "";

    return (
        <UI.List.Row className={styles.TicketListRow} key={realestate.id}>
            <UI.List.Cell colspan={widths[0]} value={realestate.name} truncate />
            <UI.List.Cell colspan={widths[1]} value={realestate.number} truncate />
            <UI.List.Cell value={formatAddress} colspan={widths[2]} />
            <UI.List.Cell
                key={"c-1"}
                colspan={widths[3]}
                value={
                    <UI.Icon
                        icon={UI.SVGIcon.Trash}
                        onClick={onRemoveRealestate(realestate.id)}
                        className={styles.TrashIcon}
                    />
                }
                className="d-flex justify-content-center"
            />
        </UI.List.Row>
    );
};

export const AssemblyRealestateListRowDesktop = Sentry.withProfiler(observer(AssemblyRealestateListRowDesktopBase));
